

































import Vue from 'vue';

/**
 * TODO: May need to change all references to STooltip to listen to events. E.g
 * <template v-slot:activator="{ on }"><v-btn v-on="on" /></template>
 */
export default Vue.extend({
  name: 'STooltip',
  props: {
    /**
     * The position of the tooltip
     */
    position: {
      type: String,
      required: false,
      default: 'top',
    },
    /**
     * The background colour of the tooltip
     */
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    /**
     * The z-index of the tooltip
     */
    zIndex: {
      type: Number,
      required: false,
      default: 2,
    },
    /**
     * Should the tooltip content render on hover or on component mount?
     * @deprecated lazy has been removed in vuetify 2
     */
    lazy: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Keep the tooltip next to the trigger in the DOM and use CSS to position. Not as 'intellegent'
     * and should be used with care, but it can fix bugs and reduce complex JS calculations.
     */
    simplePosition: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Nudge the content to the right
     */
    nudgeRight: {
      type: Number,
    },
  },
});
